import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowCircleLeft,
  faArrowCircleRight,
  faBan,
  faCalendar,
  faBolt,
  faCamera,
  faCaretDown,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faChevronCircleDown,
  faChevronCircleUp,
  faCircle,
  faClock,
  faComment,
  faCommentAlt,
  faCommentDots,
  faComments,
  faCreditCard,
  faDollarSign,
  faDownload,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFileExcel,
  faFlag,
  faImage,
  faImages,
  faInfoCircle,
  faMinusSquare,
  faPlus,
  faPrint,
  faQuestionCircle,
  faRss,
  faSearch,
  faShoppingCart,
  faSort,
  faTimesCircle,
  faTrashAlt,
  faTruck,
  faUpload,
  faUniversity,
  faUsers,
  faWifi
} from '@fortawesome/free-solid-svg-icons';

import { faFacebook } from '@fortawesome/free-brands-svg-icons';

// ES6 Polyfills must be imported as needed here for IE11 compatibility
import 'core-js/es6/promise';
import 'core-js/fn/object/assign';
import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';
import 'core-js/fn/number/is-nan';
import 'core-js/fn/array/find-index';

import createPlugin from 'bugsnag-react';

import store from './store';
import App from './components/app';
import ScrollToTop from './utilities/form-components/ScrollToTop';
import { unregister } from './registerServiceWorker';
import bugsnagClient from './bugsnagClient';
import theme from './utilities/MUICustomizedTheme';

library.add(
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowCircleLeft,
  faArrowCircleRight,
  faBan,
  faCalendar,
  faBolt,
  faCamera,
  faCaretDown,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faChevronCircleDown,
  faChevronCircleUp,
  faCircle,
  faClock,
  faComment,
  faCommentAlt,
  faCommentDots,
  faComments,
  faCreditCard,
  faDollarSign,
  faDownload,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFacebook,
  faFileExcel,
  faFlag,
  faImage,
  faImages,
  faInfoCircle,
  faMinusSquare,
  faPlus,
  faPrint,
  faQuestionCircle,
  faRss,
  faSearch,
  faShoppingCart,
  faSort,
  faTimesCircle,
  faTrashAlt,
  faTruck,
  faUniversity,
  faUpload,
  faUsers,
  faWifi
);

const target = document.querySelector('#root');
const ErrorBoundary = bugsnagClient.use(createPlugin(React));

// React 18: Use createRoot instead of render
const root = createRoot(target);
root.render(
  <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter basename={process.env.NODE_ENV === 'development' ? '' : 'ar'}>
          <ScrollToTop>
            <App />
          </ScrollToTop>
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  </ErrorBoundary>
);

unregister();
